/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import wamClient from '@messaging/bifrost';
import getConfig from '../config';
import {getEnvironment} from '../utils/Environment';
// import appsUtils from '../src/containers/Apps/AppsUtils';

class ThorUtil {
	// Singleton
	static instance: any;
	static thorProductsList: any;

	constructor() {
		if (!ThorUtil.instance) {
			ThorUtil.instance = this;
		}
		return ThorUtil.instance;
	}

	getProductsList() {
		return ThorUtil.thorProductsList;
	}

	getWamClient() {
		return wamClient;
	}

	initializeWAMClient() {
		if (window.cchome.util.hasFeature('temp_enable_force_kaizen')) {
			return;
		}
		const initialTime = performance.now();
		// const startupLocale = window.cchome.util.getStartupLanguage();
		// const isNewCCWebExperienceOnNonEnLocale = appsUtils.isNewCCWebExperience(startupLocale) && startupLocale !== 'en';
		const initConfigJson = {
			env: getEnvironment() !== 'prod' ? 'stage' : 'prod',
			clientId: getConfig('CLIENT_ID'),
			userContext: {
				accessToken: window.cchome.util.getAccessToken(),
				email: window.cchome.util.getUserEmail(),
				displayName: window.cchome.util.getUserDisplayName(),
			},
			analyticsParams: {
				setSourceName: 'CCHome',
				setSourceVersion: '1.0',
				setSourceClientId: 'CCHomeWeb1',
				setSourcePlatform: 'web',
			},
			isLoggingEnabled: false,
			shouldTryHttpPing: window.cchome.util.hasFeature('temp_enable_http_ping'),
			callbacks: {
				onSuccessCallback: () => {
					window.cchome.util.hasFeature('temp_enable_wam_logs')
						&& window.cchome.util.logger.log(
							'ThorUtils',
							'Connection with Thor via WAM is established',
							performance.now() - initialTime,
						);
				},
				onFailureCallback: (err) => {
					if (err && err.error && err.error.code && err.error.desc) {
						window.cchome.util.hasFeature('temp_enable_wam_logs')
							&& window.cchome.util.logger.error(
								'ThorUtils',
								`Connection with Thor via WAM could not be established, error code is: ${err.error.code}, ${err.error.desc}`,
								performance.now() - initialTime,
							);
					}
				},
				onMessageCallback: (thorProductsList) => {
					if (thorProductsList) {
						ThorUtil.thorProductsList = thorProductsList;
						window.cchome.util.hasFeature('temp_enable_wam_logs')
							&& window.cchome.util.logger.log(
								'ThorUtils',
								'Products list returned',
								performance.now() - initialTime,
							);
					}
				},
				clientTokenExpiryCheck: () => {
					const isUserTokenValid
						= typeof window.adobeIMS !== 'undefined'
						&& typeof window.adobeIMS.isSignedInUser() !== 'undefined';
					if (!isUserTokenValid) {
						setTimeout(() => {
							// eslint-disable-next-line no-self-assign
							window.location.href = window.location.href;
						}, 5000);
					}
					return isUserTokenValid;
				},
			},
		};
		wamClient.initialize(initConfigJson);
	}
}

export default new ThorUtil();
